import producer from "immer";

const INITIAL_STATE = {
	loading: false,
	vl_full_phone_number: null,
	token: undefined,
	recoverFail: [],
	pinCodeFail: false,
	respAccountRecoverWithType: [],
};

export default function recoverPassword(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@recover/RECOVER_PASSWORD_FOR_PHONE_REQUEST": (draft) => {
			draft.loading = true;
		},
		"@recover/RECOVER_PASSWORD_FOR_PHONE_SUCCESS": (draft) => {
			draft.loading = false;
			draft.vl_full_phone_number = action.payload.vl_full_phone_number;
		},
		"@recover/RECOVER_PASSWORD_FOR_PHONE_FAIL": (draft) => {
			draft.loading = false;
		},
		"@recover/VALIDATE_TOKEN_CONFIRM_PHONE_REQUEST": (draft) => {
			draft.loading = false;
		},
		"@recover/VALIDATE_TOKEN_CONFIRM_PHONE_SUCCESS": (draft) => {
			draft.loading = false;
		},
		"@recover/VALIDATE_TOKEN_CONFIRM_PHONE_FAIL": (draft) => {
			draft.loading = false;
		},
		"@recover/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@recover/SEND_TOKEN": (draft) => {
			draft.token = action.payload.token;
		},
		"@recover/SHOW_MESSAGE_RECOVER_FAILED": (draft) => {
			draft.recoverFail = action.payload;
		},
		"@recover/RECOVER_PIN_CODE_FAILED": (draft) => {
			draft.pinCodeFail = action.payload.param;
		},
		"@recover/RESP_ACCOUNT_RECOVER_WITH_TYPE": (draft) => {
			draft.respAccountRecoverWithType = action.payload.data;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
